export const getFeesPanelStyle = (theme) => ({
    width: '100%',
    maxWidth: theme.isDesktop() ? '60rem' : 'calc(100% - 1.5rem)',
    marginLeft: 'auto',
    marginRight: 'auto',
});
